// extracted by mini-css-extract-plugin
export var alertsChanges = "styles-module__alertsChanges___wsnW2";
export var body = "styles-module__body___rSgxK";
export var buttonRow = "styles-module__buttonRow___Yb9wE";
export var checkbox = "styles-module__checkbox___IcdZ1";
export var content = "styles-module__content___O4eso";
export var divider = "styles-module__divider___S2ls8";
export var highlighted = "styles-module__highlighted___uUcNO";
export var leftPanel = "styles-module__leftPanel___Q50nm";
export var location = "styles-module__location___xMGR0";
export var locationPanel = "styles-module__locationPanel___f0u2G";
export var table = "styles-module__table___OanD9";
export var tagDelete = "styles-module__tagDelete___glrE8";
export var trailsPanel = "styles-module__trailsPanel___fIR4t";